module.exports = __webpack_public_path__ + "static/media/with-brand-name-and-image.88d5ddbf.svg";